export const DELETE_PROOF_FILE_REQUEST = 'DELETE_PROOF_FILE_REQUEST';
export const DELETE_PROOF_FILE_SUCCESS = 'DELETE_PROOF_FILE_SUCCESS';
